import React, { FC } from 'react';
import { ApprovalHeaderProps } from './ApprovalHeaderProps';
import { Stack } from '@mui/material';
import ApprovalPageStats from '../ApprovalPageStats';
import Text from '@ingka/text';
import ApprovalHeaderCrpSelect from '../ApprovalHeaderCrpSelect';

const ApprovalHeader: FC<ApprovalHeaderProps> = ({
  selectedCRPValues,
  onSelectedCRPValuesChange,
  stats,
  loading,
}) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack flex={4} alignContent={'space-between'}>
        <Text style={{ flex: 1 }} textStyle={'Heading.L'}>
          Approval
        </Text>
        <ApprovalHeaderCrpSelect
          selectedValues={selectedCRPValues}
          onChange={onSelectedCRPValuesChange}
        />
      </Stack>
      <ApprovalPageStats stats={stats} loading={loading} />
    </Stack>
  );
};

export default ApprovalHeader;
